export default "__VITE_PUBLIC_ASSET__492a7159__"